<template>
  <div class="page-wrapper">
    <!-- 通用提示 -->
    <transition name="slide-down">
      <div class="new-user-toast" v-if="showToast" @click="handleToastClick">
        <div class="toast-icon">
          <svg viewBox="0 0 24 24" width="18" height="18">
            <path fill="#4CAF50" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
          </svg>
        </div>
        <span class="toast-text">{{ toastMessage }}</span>
        <button class="toast-close" @click.stop="closeToast">×</button>
      </div>
    </transition>

    <!-- 主内容区域 -->
    <transition :name="transitionName">
      <div class="main-content" v-if="activeTab === 'home'" key="home">
        <div class="content">
          <!-- 顶部标题 -->
          <div class="page-title" v-fade-down>白菜台</div>

          <!-- 用户信息卡片 -->
          <div class="info-card" v-motion="{ initial: { opacity: 0, y: 18, scale: 0.98 }, animate: { opacity: 1, y: 0, scale: 1 }, transition: { type: 'spring', stiffness: 260, damping: 24, delay: 0.06 } }">
            <div class="info-row">
              <span class="info-label">账号：</span>
              <span class="info-value">{{ account }}</span>
              <span v-if="!isGuest" class="admin-badge">管理员账号</span>
              <span v-else class="guest-badge">访客</span>
              <span class="arrow">›</span>
            </div>
            <div class="info-row">
              <span class="info-label">到期：</span>
              <span class="info-value">{{ expireDate }}</span>
              <span class="expire-days" :class="expireClass">{{ expireText }}</span>
              <span class="arrow">›</span>
            </div>
            <div class="info-row" @click="refreshUserInfo" style="cursor: pointer;">
              <span class="info-label">余额：</span>
              <span class="info-value">{{ balance }}元</span>
              <span class="refresh-hint">点击刷新</span>
              <span class="arrow">›</span>
            </div>
          </div>

          <!-- TG频道提示 -->
          <div class="tg-notice" v-motion="{ initial: { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0 }, transition: { type: 'spring', stiffness: 240, damping: 22, delay: 0.14 } }">
            <div class="tg-title">TG频道 @lingshentop 飞机 @baicaiQWQ</div>
            <div class="tg-desc">请联系唯一飞机购买，不在我本人这里购买的无售后</div>
            <div class="tg-desc">源码均为白菜制作无售卖，具体看白菜频道 @lingshentop</div>
          </div>

          <!-- 功能按钮网格 -->
          <div class="feature-grid" v-motion="{ initial: { opacity: 0, y: 20 }, animate: { opacity: 1, y: 0 }, transition: { type: 'spring', stiffness: 220, damping: 22, delay: 0.22 } }">
            <div class="feature-item" :class="{ 'disabled-feature': isExpired && role !== 'admin' }" @click="openSharePage">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M24 21.94h976v976H24z" fill="#EBEBEB"></path>
                  <path d="M395.648 394.172H156.896V155.42h238.752v238.752z m-158.752-80h78.752V235.42H236.896v78.752zM869.072 394.172H630.32V155.42h238.752v238.752z m-158.752-80h78.752V235.42H710.32v78.752zM395.648 870.428H156.896V631.68h238.752v238.748z m-158.752-80h78.752V711.68H236.896v78.748zM585.584 354.172h-80V235.42h-62.056v-80h142.056zM236.896 583.8h-80v-142.056h150.56v80.004h-70.56zM404.264 418.492h80v158.752h-80zM710.32 667.468h-80v-118.756h-62.064v-80h142.064zM780.572 469.024h80v194.152h-80zM435.024 631.68h155.916v80h-155.916zM635.196 871.852H436.44v-80h118.756v-62.056h80zM781.192 867.28h-80v-142.044h164.728v80h-84.728z" fill="#666666"></path>
                </svg>
              </div>
              <span class="feature-text">分享页</span>
            </div>

            <div class="feature-item" :class="{ 'disabled-feature': isExpired && role !== 'admin' }" @click="openFukuantu">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M913.511491 913.927599c0 60.537454-49.534948 110.067667-110.067667 110.067667H220.542995C160.005541 1023.995266 110.475327 974.465052 110.475327 913.927599V110.067667C110.475327 49.530214 160.005541 0 220.542995 0h582.905563c60.532719 0 110.067667 49.530214 110.067667 110.067667l-0.004734 803.859932z" fill="#EDEDED"></path>
                  <path d="M255.993409 186.302903h517.38763v47.342969H255.993409zM255.993409 341.461159h377.257178v47.342969H255.993409zM255.993409 496.414695h517.38763v47.342968H255.993409zM255.993409 651.363496h447.324771v47.342968H255.993409zM255.993409 806.307563h188.633323v47.342968H255.993409z" fill="#00CCC6"></path>
                </svg>
              </div>
              <span class="feature-text">付款图</span>
            </div>

            <div class="feature-item" :class="{ 'disabled-feature': isExpired && role !== 'admin' }" @click="openPaymentPage">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M962.45708 400.932164c0 24.077322-19.697958 43.775279-43.775279 43.775279H107.76036c-24.077322 0-43.770689-19.697958-43.770689-43.775279V43.775279C63.989671 19.697958 83.683038 0 107.76036 0H918.681801c24.077322 0 43.775279 19.697958 43.775279 43.775279v357.156885z" fill="#00CCC6"></path>
                  <path d="M60.666129 156.302903h902.667742v867.697097H60.666129z" fill="#F5F5F5"></path>
                  <path d="M141.98275 77.336633m-26.423082 0a26.423082 26.423082 0 1 0 52.846163 0 26.423082 26.423082 0 1 0-52.846163 0Z" fill="#FF8097"></path>
                  <path d="M230.68094 77.336633m-26.423081 0a26.423082 26.423082 0 1 0 52.846163 0 26.423082 26.423082 0 1 0-52.846163 0Z" fill="#FFCB8F"></path>
                  <path d="M325.672746 77.336633m-26.423082 0a26.423082 26.423082 0 1 0 52.846163 0 26.423082 26.423082 0 1 0-52.846163 0Z" fill="#9AE3B0"></path>
                  <path d="M623.32261 621.291301v39.395915h204.278516v-39.395915h-204.278516z m0 138.620188h116.732548v-39.395915h-116.732548v39.395915z" fill="#B2B2B2" opacity=".27"></path>
                  <path d="M826.136748 895.846217c0 22.870013-19.693367 41.585597-43.770689 41.585598h-115.26817c-24.072731 0-43.770689-18.710994-43.770688-41.585598s19.697958-41.585597 43.770688-41.585597h115.26817c24.072731 0 43.770689 18.710994 43.770689 41.585597z" fill="#FF7D7D"></path>
                  <path d="M405.226604 621.089318c0 17.402693-30.522424 39.827425-68.169348 39.827425-37.656105 0-68.169347-22.424731-68.169347-39.827425l-4.59971-0.449872H233.958578l-90.897054 90.897054 58.666953 60.342497 32.230101-32.22551v197.773737h207.826994v-197.782918l30.820808 30.825398 58.662363-60.342496-87.8214-89.478581h-33.409866l-4.810873 0.440691z" fill="#B2B2B2" opacity=".27"></path>
                  <path d="M146.206036 242.664515h722.241612v249.504402H146.206036z" fill="#00CCC6" opacity=".46"></path>
                </svg>
              </div>
              <span class="feature-text">付款页</span>
            </div>

            <div class="feature-item" @click="showSettingsPage = true">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M512.002132 512.002132m-130.775205 0a130.775205 130.775205 0 1 0 261.55041 0 130.775205 130.775205 0 1 0-261.55041 0Z" fill="#F06262"></path>
                  <path d="M512.002132 674.755885c-89.740333 0-162.753753-73.01342-162.753753-162.753753S422.261799 349.248379 512.002132 349.248379s162.753753 73.01342 162.753753 162.753753-73.01342 162.753753-162.753753 162.753753z m0-261.55041c-54.47439 0-98.796657 44.322267-98.796657 98.796657 0 54.478654 44.322267 98.796657 98.796657 98.796657 54.478654 0 98.796657-44.322267 98.796657-98.796657S566.480786 413.205475 512.002132 413.205475z" fill="#B34848"></path>
                  <path d="M1024 565.299711v-106.595159h-104.663655a413.141518 413.141518 0 0 0-27.902349-104.224482l90.618677-52.316904-53.29758-92.311408-90.337265 52.154879a420.863271 420.863271 0 0 0-75.968238-77.187686l51.711444-89.569781-92.307144-53.297579-51.042026 88.405761a413.576426 413.576426 0 0 0-105.512153-29.791215V0h-106.595159v98.984265a413.900475 413.900475 0 0 0-107.904147 27.22014L302.154638 41.947327l-92.315672 53.29758 47.946503 83.046156a420.552013 420.552013 0 0 0-80.756493 78.778086L95.240643 209.847494l-53.29758 92.315672 80.701063 46.590612a413.576426 413.576426 0 0 0-30.315663 109.959302H0v106.595159h91.966039a413.665966 413.665966 0 0 0 29.701676 110.526389l-79.720388 46.00647 53.293316 92.311408 80.304529-46.351839a420.701246 420.701246 0 0 0 81.106124 79.873885l-46.808066 81.076278 92.311408 53.297579 47.336778-81.988732a414.028389 414.028389 0 0 0 109.213136 27.753115v96.182944h106.595159v-97.764816a413.887684 413.887684 0 0 0 106.795558-30.354037l49.750093 86.171526 92.307144-53.297579-50.594326-87.64254a420.326031 420.326031 0 0 0 76.339189-78.257902l88.866252 51.29359 53.284788-92.315671-89.69343-51.779665a413.43572 413.43572 0 0 0 27.335262-104.757458h104.309759v0.008527z m-518.167596 258.599856c-171.208881 0-310.498907-139.290026-310.498907-310.498907s139.285762-310.498907 310.498907-310.498907c171.208881 0 310.498907 139.290026 310.498907 310.498907s-139.290026 310.498907-310.498907 310.498907z" fill="#F06262"></path>
                </svg>
              </div>
              <span class="feature-text">设置</span>
            </div>

            <!-- 管理功能（管理员和子管理员可见，根据权限控制） -->
            <div class="feature-item" v-if="role === 'admin' || role === 'manager'" @click="showUserManagement = true">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M512 64c-176.736 0-320 143.264-320 320v64c0 176.736 143.264 320 320 320s320-143.264 320-320v-64c0-176.736-143.264-320-320-320z" fill="#E8F4FF"></path>
                  <path d="M512 512c-88.368 0-160-71.632-160-160s71.632-160 160-160 160 71.632 160 160-71.632 160-160 160z" fill="#5B8FF9"></path>
                  <path d="M512 512c-88.368 0-160-71.632-160-160s71.632-160 160-160 160 71.632 160 160-71.632 160-160 160z m0-256c-52.928 0-96 43.072-96 96s43.072 96 96 96 96-43.072 96-96-43.072-96-96-96z" fill="#3B7DE9"></path>
                  <path d="M832 896H192c-17.664 0-32-14.336-32-32v-64c0-141.152 114.848-256 256-256h192c141.152 0 256 114.848 256 256v64c0 17.664-14.336 32-32 32z" fill="#5B8FF9"></path>
                  <path d="M608 544H416c-141.152 0-256 114.848-256 256v64c0 17.664 14.336 32 32 32h640c17.664 0 32-14.336 32-32v-64c0-141.152-114.848-256-256-256z m192 288H224v-32c0-105.872 86.128-192 192-192h192c105.872 0 192 86.128 192 192v32z" fill="#3B7DE9"></path>
                </svg>
              </div>
              <span class="feature-text">用户管理</span>
            </div>

            <div class="feature-item" v-if="role === 'admin' || role === 'manager'" @click="showInterfaceManagement = true">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M896 128H128c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h768c35.2 0 64-28.8 64-64V192c0-35.2-28.8-64-64-64z" fill="#E8FFF3"></path>
                  <path d="M896 128H128c-35.2 0-64 28.8-64 64v96h896v-96c0-35.2-28.8-64-64-64z" fill="#61DDAA"></path>
                  <path d="M160 208m-24 0a24 24 0 1 0 48 0 24 24 0 1 0-48 0Z" fill="#FF8097"></path>
                  <path d="M240 208m-24 0a24 24 0 1 0 48 0 24 24 0 1 0-48 0Z" fill="#FFCB8F"></path>
                  <path d="M320 208m-24 0a24 24 0 1 0 48 0 24 24 0 1 0-48 0Z" fill="#9AE3B0"></path>
                  <path d="M192 384h256v48H192zM192 496h384v48H192zM192 608h320v48H192zM192 720h192v48H192z" fill="#61DDAA"></path>
                  <path d="M640 384h192v48H640zM640 496h192v48H640zM640 608h192v48H640zM640 720h192v48H640z" fill="#B2E5D3"></path>
                </svg>
              </div>
              <span class="feature-text">接口管理</span>
            </div>

            <div class="feature-item" v-if="role === 'admin'" @click="showSystemSettings = true">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M512 320c-105.872 0-192 86.128-192 192s86.128 192 192 192 192-86.128 192-192-86.128-192-192-192z" fill="#FFF3E0"></path>
                  <path d="M512 640c-70.576 0-128-57.424-128-128s57.424-128 128-128 128 57.424 128 128-57.424 128-128 128z" fill="#F6BD16"></path>
                  <path d="M512 448c-35.296 0-64 28.704-64 64s28.704 64 64 64 64-28.704 64-64-28.704-64-64-64z" fill="#E5A800"></path>
                  <path d="M924.8 467.2l-83.2-14.4c-8-28.8-20.8-56-36.8-80l48-70.4c5.6-8 4-18.4-2.4-24.8l-51.2-51.2c-6.4-6.4-16.8-8-24.8-2.4l-70.4 48c-24-16-51.2-28.8-80-36.8l-14.4-83.2c-1.6-9.6-9.6-16-19.2-16h-72c-9.6 0-17.6 6.4-19.2 16l-14.4 83.2c-28.8 8-56 20.8-80 36.8l-70.4-48c-8-5.6-18.4-4-24.8 2.4l-51.2 51.2c-6.4 6.4-8 16.8-2.4 24.8l48 70.4c-16 24-28.8 51.2-36.8 80l-83.2 14.4c-9.6 1.6-16 9.6-16 19.2v72c0 9.6 6.4 17.6 16 19.2l83.2 14.4c8 28.8 20.8 56 36.8 80l-48 70.4c-5.6 8-4 18.4 2.4 24.8l51.2 51.2c6.4 6.4 16.8 8 24.8 2.4l70.4-48c24 16 51.2 28.8 80 36.8l14.4 83.2c1.6 9.6 9.6 16 19.2 16h72c9.6 0 17.6-6.4 19.2-16l14.4-83.2c28.8-8 56-20.8 80-36.8l70.4 48c8 5.6 18.4 4 24.8-2.4l51.2-51.2c6.4-6.4 8-16.8 2.4-24.8l-48-70.4c16-24 28.8-51.2 36.8-80l83.2-14.4c9.6-1.6 16-9.6 16-19.2v-72c0-9.6-6.4-17.6-16-19.2z" fill="#F6BD16"></path>
                </svg>
              </div>
              <span class="feature-text">系统设置</span>
            </div>

            <div class="feature-item" v-if="role === 'admin' || role === 'manager'" @click="showPasswordManagement = true">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M832 384h-64v-96c0-141.152-114.848-256-256-256S256 146.848 256 288v96h-64c-35.2 0-64 28.8-64 64v448c0 35.2 28.8 64 64 64h640c35.2 0 64-28.8 64-64V448c0-35.2-28.8-64-64-64z" fill="#EDE7F6"></path>
                  <path d="M320 384v-96c0-105.872 86.128-192 192-192s192 86.128 192 192v96H320z" fill="#7262FD"></path>
                  <path d="M832 448v448H192V448h640z" fill="#9575CD"></path>
                  <path d="M512 576c-35.2 0-64 28.8-64 64 0 23.2 12.8 44 32 55.2V768c0 17.6 14.4 32 32 32s32-14.4 32-32v-72.8c19.2-11.2 32-32 32-55.2 0-35.2-28.8-64-64-64z" fill="#EDE7F6"></path>
                </svg>
              </div>
              <span class="feature-text">密码管理</span>
            </div>

            <div class="feature-item" v-if="role === 'admin'" @click="showOrderManagement = true">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M896 128H128c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h768c35.2 0 64-28.8 64-64V192c0-35.2-28.8-64-64-64z" fill="#E3F2FD"></path>
                  <path d="M896 128H128c-35.2 0-64 28.8-64 64v96h896v-96c0-35.2-28.8-64-64-64z" fill="#2196F3"></path>
                  <path d="M160 208m-24 0a24 24 0 1 0 48 0 24 24 0 1 0-48 0Z" fill="#FF8097"></path>
                  <path d="M240 208m-24 0a24 24 0 1 0 48 0 24 24 0 1 0-48 0Z" fill="#FFCB8F"></path>
                  <path d="M320 208m-24 0a24 24 0 1 0 48 0 24 24 0 1 0-48 0Z" fill="#9AE3B0"></path>
                  <path d="M192 384h256v48H192zM192 496h640v48H192zM192 608h640v48H192zM192 720h384v48H192z" fill="#2196F3"></path>
                  <path d="M704 384h128v48H704z" fill="#4CAF50"></path>
                </svg>
              </div>
              <span class="feature-text">订单管理</span>
            </div>

            <div class="feature-item" v-if="role === 'admin'" @click="showSystemMonitoring = true">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M896 128H128c-35.2 0-64 28.8-64 64v512c0 35.2 28.8 64 64 64h320v96H320c-17.6 0-32 14.4-32 32s14.4 32 32 32h384c17.6 0 32-14.4 32-32s-14.4-32-32-32h-128v-96h320c35.2 0 64-28.8 64-64V192c0-35.2-28.8-64-64-64z" fill="#E3F2FD"></path>
                  <path d="M256 480l128-160 128 96 160-192 96 128" stroke="#2196F3" stroke-width="48" stroke-linecap="round" stroke-linejoin="round" fill="none"></path>
                  <circle cx="256" cy="480" r="24" fill="#4CAF50"></circle>
                  <circle cx="384" cy="320" r="24" fill="#4CAF50"></circle>
                  <circle cx="512" cy="416" r="24" fill="#4CAF50"></circle>
                  <circle cx="672" cy="224" r="24" fill="#4CAF50"></circle>
                  <circle cx="768" cy="352" r="24" fill="#4CAF50"></circle>
                </svg>
              </div>
              <span class="feature-text">系统监控</span>
            </div>

            <div class="feature-item" v-if="role === 'admin' || role === 'manager'" @click="showCustomAntiRed = true">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z" fill="#E8F5E9"></path>
                  <path d="M512 128c212.1 0 384 171.9 384 384S724.1 896 512 896 128 724.1 128 512s171.9-384 384-384z" fill="#4CAF50"></path>
                  <path d="M512 256c-141.4 0-256 114.6-256 256s114.6 256 256 256 256-114.6 256-256-114.6-256-256-256z m0 448c-106 0-192-86-192-192s86-192 192-192 192 86 192 192-86 192-192 192z" fill="#81C784"></path>
                  <path d="M512 384c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128-57.3-128-128-128z" fill="#FFFFFF"></path>
                </svg>
              </div>
              <span class="feature-text">自定义防红</span>
            </div>

            <div class="feature-item" v-if="role === 'admin'" @click="showLicenseManagement = true">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M512 64l-448 192v256c0 247.424 171.008 478.72 448 512 276.992-33.28 448-264.576 448-512V256L512 64z" fill="#FFF3E0"></path>
                  <path d="M512 128l-384 164.8v219.2c0 211.968 146.432 410.112 384 438.4 237.568-28.288 384-226.432 384-438.4V292.8L512 128z" fill="#F6BD16"></path>
                  <path d="M512 256c-141.376 0-256 114.624-256 256s114.624 256 256 256 256-114.624 256-256-114.624-256-256-256z m0 448c-105.984 0-192-86.016-192-192s86.016-192 192-192 192 86.016 192 192-86.016 192-192 192z" fill="#E5A800"></path>
                  <path d="M512 384c-70.592 0-128 57.408-128 128s57.408 128 128 128 128-57.408 128-128-57.408-128-128-128z" fill="#FFFFFF"></path>
                  <path d="M448 512l48 48 96-96" stroke="#F6BD16" stroke-width="32" stroke-linecap="round" stroke-linejoin="round" fill="none"></path>
                </svg>
              </div>
              <span class="feature-text">授权管理</span>
            </div>

            <div class="feature-item" v-if="role === 'admin'" @click="showAnnouncementManagement = true">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <path d="M896 128H128c-35.2 0-64 28.8-64 64v512c0 35.2 28.8 64 64 64h256l128 128 128-128h256c35.2 0 64-28.8 64-64V192c0-35.2-28.8-64-64-64z" fill="#E3F2FD"></path>
                  <path d="M896 128H128c-35.2 0-64 28.8-64 64v512c0 35.2 28.8 64 64 64h256l128 128 128-128h256c35.2 0 64-28.8 64-64V192c0-35.2-28.8-64-64-64z" fill="#42A5F5" opacity="0.3"></path>
                  <path d="M512 288c-17.6 0-32 14.4-32 32v256c0 17.6 14.4 32 32 32s32-14.4 32-32V320c0-17.6-14.4-32-32-32z" fill="#1565C0"></path>
                  <circle cx="512" cy="672" r="32" fill="#1565C0"></circle>
                </svg>
              </div>
              <span class="feature-text">公告管理</span>
            </div>

            <div class="feature-item" v-if="role === 'admin'" @click="showRedEnvelopeManagement = true">
              <div class="feature-icon">
                <svg viewBox="0 0 1024 1024" width="24" height="24">
                  <rect x="128" y="192" width="768" height="640" rx="48" fill="#E53935"/>
                  <rect x="128" y="192" width="768" height="240" rx="0" fill="#C62828"/>
                  <circle cx="512" cy="432" r="80" fill="#FFD700" stroke="#FFF" stroke-width="8"/>
                  <rect x="464" y="512" width="96" height="240" rx="8" fill="#FFD700"/>
                  <path d="M128 432h768" stroke="#B71C1C" stroke-width="4" opacity="0.3"/>
                </svg>
              </div>
              <span class="feature-text">红包管理</span>
            </div>

            <div class="feature-item logout-item" @click="logout">
              <div class="feature-icon">
                <svg viewBox="0 0 1182 1024" width="24" height="24">
                  <path d="M295.598598 1024L0 512.002621 295.598598 0h591.207677L1182.415355 512.002621l-295.60908 511.997379z" fill="#F78383"></path>
                  <path d="M591.207678 590.542045c-28.947163 0-52.412028-23.470106-52.412029-52.412028V228.044734c0-28.947163 23.464865-52.412028 52.412029-52.412028 28.941922 0 52.412028 23.464865 52.412028 52.412028v310.085283c0 28.941922-23.464865 52.412028-52.412028 52.412028zM591.207678 809.131649c-28.947163 0-52.412028-23.470106-52.412029-52.412028V700.801228c0-28.941922 23.464865-52.412028 52.412029-52.412028 28.941922 0 52.412028 23.470106 52.412028 52.412028v55.918393c0 28.941922-23.464865 52.412028-52.412028 52.412028z" fill="#FFFFFF"></path>
                </svg>
              </div>
              <span class="feature-text">退出</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 聊天内容区域 -->
      <div class="main-content chat-content" v-else-if="activeTab === 'chat'" key="chat">
        <ChatPage />
      </div>
    </transition>

    <!-- 底部导航 -->
    <div class="custom-tabbar">
      <div class="tab-item" :class="{ active: activeTab === 'home' }" @click="switchTab('home')">
        <svg viewBox="0 0 1024 1024" width="24" height="24">
          <path d="M544 544m112 0l224 0q112 0 112 112l0 224q0 112-112 112l-224 0q-112 0-112-112l0-224q0-112 112-112Z" :fill="activeTab === 'home' ? '#007AFF' : '#707070'"></path>
          <path d="M32 544m112 0l224 0q112 0 112 112l0 224q0 112-112 112l-224 0q-112 0-112-112l0-224q0-112 112-112Z" :fill="activeTab === 'home' ? '#007AFF' : '#707070'"></path>
          <path d="M544 32m112 0l224 0q112 0 112 112l0 224q0 112-112 112l-224 0q-112 0-112-112l0-224q0-112 112-112Z" :fill="activeTab === 'home' ? '#007AFF' : '#707070'"></path>
          <path d="M32 32m112 0l224 0q112 0 112 112l0 224q0 112-112 112l-224 0q-112 0-112-112l0-224q0-112 112-112Z" :fill="activeTab === 'home' ? '#007AFF' : '#707070'"></path>
        </svg>
        <span class="tab-text">主页</span>
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'chat', disabled: !canUseChat }" @click="switchTab('chat')">
        <svg viewBox="0 0 1024 1024" width="24" height="24">
          <path d="M960 624h-256c-26.24 0-48-21.76-48-48s21.76-48 48-48h256c26.24 0 48 21.76 48 48s-21.76 48-48 48zM960 816h-256c-26.24 0-48-21.76-48-48s21.76-48 48-48h256c26.24 0 48 21.76 48 48s-21.76 48-48 48zM960 1008h-256c-26.24 0-48-21.76-48-48s21.76-48 48-48h256c26.24 0 48 21.76 48 48s-21.76 48-48 48z" :fill="activeTab === 'chat' ? '#007AFF' : '#707070'"></path>
          <path d="M620.16 864C593.28 840.32 576 806.4 576 768s17.28-72.32 44.16-96C593.28 648.32 576 614.4 576 576c0-30.72 11.52-58.88 29.44-81.28-19.84-7.68-39.68-14.72-60.8-19.84A239.808 239.808 0 0 0 448 15.36c-132.48 0-240 107.52-240 240 0 97.92 58.88 181.76 143.36 219.52C159.36 519.04 16 691.2 16 896c0 21.76 1.92 42.88 5.12 64 0 2.56 0 5.12 0.64 7.68 0 1.92 1.28 3.2 1.92 5.12 0.64 3.2 1.92 6.4 3.2 8.96 1.28 3.2 3.2 5.76 5.12 8.32 1.92 1.92 3.2 3.84 5.12 5.76 2.56 2.56 5.76 4.48 8.96 6.4a19.2 19.2 0 0 0 6.4 2.56c3.84 1.28 7.04 1.92 10.88 2.56 1.92 0 3.2 0.64 4.48 0.64h516.48c-5.76-14.72-9.6-30.72-9.6-48 0-38.4 17.28-72.32 44.16-96z" :fill="activeTab === 'chat' ? '#007AFF' : '#707070'"></path>
        </svg>
        <span class="tab-text">聊天</span>
      </div>
    </div>

    <!-- 分享页面全屏弹窗 -->
    <div class="share-page-overlay" v-if="showSharePage">
      <SharePage @close="closeSharePage" @copy-success="showCopyToast('链接已复制')" />
    </div>

    <!-- 续费页面全屏弹窗 -->
    <div class="share-page-overlay" v-if="showXufeiPage">
      <XufeiPage @close="showXufeiPage = false" />
    </div>

    <!-- 风控图页面全屏弹窗 -->
    <div class="share-page-overlay" v-if="showFengkongtuPage">
      <FengkongtuPage @close="showFengkongtuPage = false" />
    </div>

    <!-- 付款图页面全屏弹窗 -->
    <div class="share-page-overlay" v-if="showFukuantuPage">
      <FukuantuPage @close="showFukuantuPage = false" />
    </div>

    <!-- 设置页面全屏弹窗 -->
    <div class="share-page-overlay" v-if="showSettingsPage">
      <SettingsPage @close="showSettingsPage = false" />
    </div>

    <!-- 付款页管理全屏弹窗 -->
    <div class="share-page-overlay" v-if="showPaymentPage">
      <PaymentPage @close="showPaymentPage = false" @copy-success="showCopyToast('已复制')" />
    </div>

    <!-- 用户管理弹窗 -->
    <div class="share-page-overlay" v-if="showUserManagement">
      <div class="management-page">
        <div class="management-header">
          <button class="back-btn" @click="showUserManagement = false">← 返回</button>
          <span class="header-title">用户管理</span>
        </div>
        <div class="management-content">
          <UserManagement />
        </div>
      </div>
    </div>

    <!-- 接口管理弹窗 -->
    <div class="share-page-overlay" v-if="showInterfaceManagement">
      <div class="management-page">
        <div class="management-header">
          <button class="back-btn" @click="showInterfaceManagement = false">← 返回</button>
          <span class="header-title">接口管理</span>
        </div>
        <div class="management-content">
          <InterfaceManagement />
        </div>
      </div>
    </div>

    <!-- 系统设置弹窗 -->
    <div class="share-page-overlay" v-if="showSystemSettings">
      <div class="management-page">
        <div class="management-header">
          <button class="back-btn" @click="showSystemSettings = false">← 返回</button>
          <span class="header-title">系统设置</span>
        </div>
        <div class="management-content">
          <SystemSettings />
        </div>
      </div>
    </div>

    <!-- 密码管理弹窗 -->
    <div class="share-page-overlay" v-if="showPasswordManagement">
      <div class="management-page">
        <div class="management-header">
          <button class="back-btn" @click="showPasswordManagement = false">← 返回</button>
          <span class="header-title">密码管理</span>
        </div>
        <div class="management-content">
          <PasswordManagement />
        </div>
      </div>
    </div>

    <!-- 订单管理弹窗 -->
    <div class="share-page-overlay" v-if="showOrderManagement">
      <div class="management-page">
        <div class="management-header">
          <button class="back-btn" @click="showOrderManagement = false">← 返回</button>
          <span class="header-title">订单管理</span>
        </div>
        <div class="management-content">
          <OrderManagement />
        </div>
      </div>
    </div>

    <!-- 自定义防红管理弹窗 -->
    <div class="share-page-overlay" v-if="showCustomAntiRed">
      <div class="management-page">
        <div class="management-header">
          <button class="back-btn" @click="showCustomAntiRed = false">← 返回</button>
          <span class="header-title">自定义防红</span>
        </div>
        <div class="management-content">
          <CustomAntiRedManagement />
        </div>
      </div>
    </div>

    <!-- 授权管理弹窗 -->
    <div class="share-page-overlay" v-if="showLicenseManagement">
      <div class="management-page">
        <div class="management-header">
          <button class="back-btn" @click="showLicenseManagement = false">← 返回</button>
          <span class="header-title">授权管理</span>
        </div>
        <div class="management-content">
          <LicenseManagement />
        </div>
      </div>
    </div>

    <!-- 系统监控弹窗 -->
    <div class="share-page-overlay" v-if="showSystemMonitoring">
      <div class="management-page">
        <div class="management-header">
          <button class="back-btn" @click="showSystemMonitoring = false">← 返回</button>
          <span class="header-title">系统监控</span>
        </div>
        <div class="management-content">
          <SystemMonitoring />
        </div>
      </div>
    </div>

    <!-- 公告管理弹窗 -->
    <div class="share-page-overlay" v-if="showAnnouncementManagement">
      <div class="management-page">
        <div class="management-header">
          <button class="back-btn" @click="showAnnouncementManagement = false">← 返回</button>
          <span class="header-title">公告管理</span>
        </div>
        <div class="management-content">
          <AnnouncementManagement />
        </div>
      </div>
    </div>

    <!-- 红包管理弹窗 -->
    <div class="share-page-overlay" v-if="showRedEnvelopeManagement">
      <div class="management-page">
        <div class="management-header">
          <button class="back-btn" @click="showRedEnvelopeManagement = false">← 返回</button>
          <span class="header-title">红包管理</span>
        </div>
        <div class="management-content">
          <RedEnvelopeManagement />
        </div>
      </div>
    </div>

    <!-- 公告弹窗 -->
    <AnnouncementPopup />

    <!-- 红包弹窗 -->
    <RedEnvelopePopup />
  </div>
</template>

<script>
import ChatPage from '../chat/chat.vue'
import SharePage from '../share/SharePage.vue'
import XufeiPage from '../home/Xufei.vue'
import FengkongtuPage from '../home/Fengkongtu.vue'
import FukuantuPage from '../home/Fukuantu.vue'
import SettingsPage from '../home/Settings.vue'
import PaymentPage from '../home/PaymentPage.vue'
import UserManagement from './components/UserManagement.vue'
import InterfaceManagement from './components/InterfaceManagement.vue'
import SystemSettings from './components/SystemSettings.vue'
import PasswordManagement from './components/PasswordManagement.vue'
import OrderManagement from './components/OrderManagement.vue'
import CustomAntiRedManagement from './components/CustomAntiRedManagement.vue'
import LicenseManagement from './components/LicenseManagement.vue'
import SystemMonitoring from './components/SystemMonitoring.vue'
import AnnouncementManagement from './components/AnnouncementManagement.vue'
import RedEnvelopeManagement from './components/RedEnvelopeManagement.vue'
import AnnouncementPopup from '@/components/AnnouncementPopup.vue'
import RedEnvelopePopup from '@/components/RedEnvelopePopup.vue'
import { getCurrentUser } from '@/api/auth.js'
import { apiFetch } from '@/config/api'
import { chatWebSocket } from '@/utils/websocket'

export default {
  name: 'HomePage',
  components: {
    ChatPage,
    SharePage,
    XufeiPage,
    FengkongtuPage,
    FukuantuPage,
    SettingsPage,
    PaymentPage,
    UserManagement,
    InterfaceManagement,
    SystemSettings,
    PasswordManagement,
    OrderManagement,
    CustomAntiRedManagement,
    LicenseManagement,
    SystemMonitoring,
    AnnouncementManagement,
    RedEnvelopeManagement,
    AnnouncementPopup,
    RedEnvelopePopup
  },
  data() {
    return {
      account: '示例账号',
      role: 'user',
      expireDays: 0,
      expireDate: '',
      isExpired: false,
      canUseChat: true,
      isGuest: false,
      hasGuestPassword: false,
      balance: '0.00',
      tgChannel: '@lingshentop',
      activeTab: 'home',
      transitionName: 'slide-left',
      showSharePage: false,
      showXufeiPage: false,
      showFengkongtuPage: false,
      showFukuantuPage: false,
      showSettingsPage: false,
      showPaymentPage: false,
      // 通用提示相关
      showToast: false,
      toastMessage: '',
      toastType: 'newUser', // 'newUser' | 'copy' | 'info'
      knownSessionKeys: new Set(),
      sessionPollingInterval: null,
      toastTimeout: null,
      // 管理功能弹窗
      showUserManagement: false,
      showInterfaceManagement: false,
      showSystemSettings: false,
      showPasswordManagement: false,
      showOrderManagement: false,
      showCustomAntiRed: false,
      showLicenseManagement: false,
      showSystemMonitoring: false,
      showAnnouncementManagement: false,
      showRedEnvelopeManagement: false
    }
  },
  computed: {
    expireText() {
      if (this.role === 'admin') return '永久'
      if (this.expireDays > 0) return `${this.expireDays} 天`
      if (this.expireDays === 0) return '今天到期'
      return `已过期${Math.abs(this.expireDays)}天`
    },
    expireClass() {
      if (this.role === 'admin') return 'expire-normal'
      if (this.expireDays < 0) return 'expire-expired'
      if (this.expireDays <= 3) return 'expire-critical'
      if (this.expireDays <= 7) return 'expire-warning'
      return 'expire-normal'
    }
  },
  provide() {
    return {
      showCopyToast: (message) => this.showCopyToast(message),
      showInfoToast: (message, duration) => this.showInfoToast(message, duration)
    }
  },
  mounted() {
    // 根据URL恢复页面状态（无刷新切换）
    this.restoreViewFromPath()

    this.loadUserInfo()
    // 立即从后端获取最新数据（包括余额）
    this.refreshUserInfo()
    // 每10秒刷新一次用户信息（包括余额）
    this.updateTimer = setInterval(() => {
      this.refreshUserInfo()
    }, 10000)
    // 启动会话轮询，检测新用户
    this.startSessionPolling()
    // 管理后台不自动连接 WebSocket，只在需要时才连接
    // 这样可以大幅减少后端资源占用
    console.log('移动端管理后台已加载，WebSocket 将在需要时自动连接')
  },
  beforeUnmount() {
    if (this.updateTimer) clearInterval(this.updateTimer)
    if (this.sessionPollingInterval) clearInterval(this.sessionPollingInterval)
    if (this.toastTimeout) clearTimeout(this.toastTimeout)
    // 退出时断开 WebSocket 连接
    this.disconnectWebSocket()
  },
  methods: {
    loadUserInfo() {
      try {
        const stored = localStorage.getItem('user')
        if (!stored) {
          window.location.href = '/'
          return
        }
        const data = JSON.parse(stored)
        this.updateUserData(data)
      } catch (e) {
        console.error('获取用户信息失败', e)
      }
    },
    async refreshUserInfo() {
      try {
        const res = await getCurrentUser()
        if (res && res.code === 0 && res.data) {
          this.updateUserData(res.data)
          const stored = localStorage.getItem('user')
          if (stored) {
            const userData = JSON.parse(stored)
            userData.expireDays = res.data.expireDays
            userData.role = res.data.role
            userData.isGuest = res.data.isGuest
            userData.hasGuestPassword = res.data.hasGuestPassword
            userData.balance = res.data.balance
            localStorage.setItem('user', JSON.stringify(userData))
          }
        }
      } catch (e) {
        console.error('刷新用户信息失败', e)
      }
    },
    updateUserData(data) {
      this.account = data.account || this.account
      this.role = data.role || 'user'
      this.isGuest = data.isGuest || false
      this.hasGuestPassword = data.hasGuestPassword || false
      // 更新余额
      if (data.balance !== undefined && data.balance !== null) {
        this.balance = parseFloat(data.balance).toFixed(2)
      }
      if (typeof data.expireDays === 'number') {
        this.expireDays = data.expireDays
        this.isExpired = data.isExpired || (this.expireDays < 0 && this.role !== 'admin')
        this.canUseChat = data.canUseChat !== undefined ? data.canUseChat : (this.role === 'admin' || this.expireDays >= 0)
        // 计算到期日期
        const now = new Date()
        now.setDate(now.getDate() + this.expireDays)
        const y = now.getFullYear()
        const m = String(now.getMonth() + 1).padStart(2, '0')
        const d = String(now.getDate()).padStart(2, '0')
        const h = String(now.getHours()).padStart(2, '0')
        const min = String(now.getMinutes()).padStart(2, '0')
        this.expireDate = `${y}-${m}-${d} ${h}:${min}`
      }
    },
    navigateTo(path) {
      if (this.isExpired) {
        alert('账号已过期，请先充值续费')
        return
      }
      alert(`跳转到: ${path} (功能开发中)`)
    },
    switchTab(tab) {
      if (tab === this.activeTab) return
      if (tab === 'chat' && !this.canUseChat) {
        alert('账号已过期，无法使用聊天功能。请先充值续费！')
        return
      }
      this.transitionName = this.activeTab === 'home' && tab === 'chat' ? 'slide-left' : 'slide-right'
      this.activeTab = tab
      this.syncTabUrl(tab)
    },
    resolveTabFromPath() {
      const path = window.location.pathname || '/'
      return path.startsWith('/admin/chat') ? 'chat' : 'home'
    },
    getAdminPath(page) {
      if (page === 'chat') return '/admin/chat'
      if (page === 'share') return '/admin/share'
      return '/admin/home'
    },
    restoreViewFromPath() {
      const path = window.location.pathname || '/'
      if (path.startsWith('/admin/share')) {
        this.activeTab = 'home'
        this.showSharePage = true
        return
      }
      this.activeTab = this.resolveTabFromPath()
      this.showSharePage = false
    },
    syncTabUrl(tab) {
      const path = this.getAdminPath(tab)
      if (window.location.pathname === path) return
      history.replaceState({ page: tab }, '', `${path}${window.location.search}`)
    },
    logout() {
      if (confirm('确定退出登录吗？')) {
        localStorage.removeItem('user')
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        window.location.href = '/'
        window.location.reload()
      }
    },
    openSharePage() {
      if (this.isExpired && this.role !== 'admin') {
        alert('账号已过期，请先充值续费')
        return
      }
      this.showSharePage = true
      const path = this.getAdminPath('share')
      history.replaceState({ page: 'share' }, '', `${path}${window.location.search}`)
    },
    closeSharePage() {
      this.showSharePage = false
      this.syncTabUrl(this.activeTab || 'home')
    },
    openFukuantu() {
      if (this.isExpired && this.role !== 'admin') {
        alert('账号已过期，请先充值续费')
        return
      }
      this.showFukuantuPage = true
    },
    openPaymentPage() {
      if (this.isExpired && this.role !== 'admin') {
        alert('账号已过期，请先充值续费')
        return
      }
      this.showPaymentPage = true
    },
    async openRecharge() {
      try {
        const res = await apiFetch('/api/settings/public/tg_username')
        if (res.code === 0 && res.data) {
          window.open(`https://t.me/${res.data}`, '_blank')
        } else {
          alert('充值功能暂未配置，请联系管理员')
        }
      } catch (e) {
        alert('充值功能暂时不可用')
      }
    },
    // 启动会话轮询
    startSessionPolling() {
      // 先加载一次初始会话列表
      this.loadSessionsForNewUser(true)
      // 每2秒检查一次新会话
      this.sessionPollingInterval = setInterval(() => {
        this.loadSessionsForNewUser(false)
      }, 2000)
    },
    // 加载会话列表检测新用户
    async loadSessionsForNewUser(isInitial) {
      try {
        const stored = localStorage.getItem('user')
        if (!stored) return
        const userData = JSON.parse(stored)
        const agentAccount = userData.account
        if (!agentAccount) return

        const response = await apiFetch(`/api/chat/sessions?agentAccount=${encodeURIComponent(agentAccount)}`)
        if (response.code === 0 && response.data) {
          const currentKeys = new Set(response.data.map(s => s.sessionKey))
          
          if (isInitial) {
            // 初始加载，只记录已有会话
            this.knownSessionKeys = currentKeys
          } else {
            // 检测新会话
            for (const session of response.data) {
              if (!this.knownSessionKeys.has(session.sessionKey)) {
                // 发现新会话，显示提示
                this.showNewUserNotification(session.customerName || session.sessionKey.split('_')[0])
                this.knownSessionKeys.add(session.sessionKey)
              }
            }
          }
        }
      } catch (e) {
        console.log('检测新用户失败:', e)
      }
    },
    // 显示新用户提示
    showNewUserNotification(userName) {
      this.toastMessage = `${userName} 新鱼加入!`
      this.toastType = 'newUser'
      this.showToast = true
      this.autoCloseToast(5000)
    },
    // 显示复制成功提示
    showCopyToast(message = '链接已复制') {
      this.toastMessage = message
      this.toastType = 'copy'
      this.showToast = true
      this.autoCloseToast(3000)
    },
    // 显示通用提示
    showInfoToast(message, duration = 3000) {
      this.toastMessage = message
      this.toastType = 'info'
      this.showToast = true
      this.autoCloseToast(duration)
    },
    // 自动关闭提示
    autoCloseToast(duration) {
      if (this.toastTimeout) clearTimeout(this.toastTimeout)
      this.toastTimeout = setTimeout(() => {
        this.showToast = false
      }, duration)
    },
    // 关闭提示
    closeToast() {
      this.showToast = false
      if (this.toastTimeout) clearTimeout(this.toastTimeout)
    },
    // 点击提示处理
    handleToastClick() {
      if (this.toastType === 'newUser' && this.canUseChat) {
        this.showToast = false
        this.switchTab('chat')
      }
    },
    // WebSocket 连接方法
    async connectWebSocket() {
      try {
        // 获取当前登录的用户账号
        const username = localStorage.getItem('username') || this.account || 'admin'

        // 初始化全局 WebSocket 连接
        await chatWebSocket.init(username)

        console.log('管理员 WebSocket 连接成功:', username)

        // 监听消息（可选：用于显示通知）
        chatWebSocket.onMessage((data) => {
          console.log('管理员收到 WebSocket 消息:', data)
          // 这里可以添加消息通知逻辑，比如显示桌面通知或更新未读消息数
        })
      } catch (error) {
        console.error('管理员 WebSocket 连接失败:', error)
        // 连接失败不影响其他功能，静默处理
      }
    },
    disconnectWebSocket() {
      try {
        chatWebSocket.close()
        console.log('管理员 WebSocket 已断开')
      } catch (error) {
        console.error('断开 WebSocket 连接失败:', error)
      }
    }
  }
}
</script>


<style scoped>
.page-wrapper {
  height: 100vh;
  height: 100dvh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #f5f5f5;
  overflow: hidden;
  position: relative;
}

.main-content {
  flex: 1;
  width: 100%;
  background-color: #f5f5f5;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 70px;
}

.chat-content {
  height: 100%;
  overflow: visible;
}

.content {
  padding: 20px 16px;
}

/* 顶部标题 */
.page-title {
  font-size: 28px;
  font-weight: 800;
  color: #333;
  margin-bottom: 20px;
  letter-spacing: 2px;
}

/* 用户信息卡片 */
.info-card {
  background: #fff;
  border-radius: 12px;
  padding: 0;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.info-row {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.18s ease;
}

.info-row:last-child {
  border-bottom: none;
}

.info-row[style*="cursor"]:active {
  background-color: #f7f7f7;
}

.info-row .arrow {
  transition: transform 0.2s ease;
}

.info-row:active .arrow {
  transform: translateX(2px);
}

.info-label {
  font-size: 15px;
  color: #666;
  width: 50px;
}

.info-value {
  font-size: 15px;
  color: #333;
  flex: 1;
}

.refresh-hint {
  font-size: 11px;
  color: #999;
  margin-right: 8px;
}

.admin-badge {
  font-size: 11px;
  color: #fff;
  background: linear-gradient(90deg, #f5a623, #f7b733);
  padding: 3px 8px;
  border-radius: 4px;
  margin-right: 8px;
}

.guest-badge {
  font-size: 11px;
  color: #fff;
  background: linear-gradient(90deg, #8e8e93, #a0a0a5);
  padding: 3px 8px;
  border-radius: 4px;
  margin-right: 8px;
}

.expire-days {
  font-size: 14px;
  padding: 2px 10px;
  border-radius: 4px;
  margin-right: 8px;
}

.expire-normal {
  color: #4caf50;
  background: #e8f5e9;
}

.expire-warning {
  color: #ff9800;
  background: #fff3e0;
}

.expire-critical {
  color: #ff5722;
  background: #fbe9e7;
}

.expire-expired {
  color: #f44336;
  background: #ffebee;
}

.arrow {
  font-size: 20px;
  color: #ccc;
}

/* TG频道提示 */
.tg-notice {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.tg-title {
  font-size: 15px;
  font-weight: 600;
  color: #d4a017;
  margin-bottom: 8px;
}

.tg-desc {
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

/* 功能按钮网格 */
.feature-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.feature-item {
  width: calc(50% - 8px);
  height: 72px;
  background: #fff;
  border-radius: 12px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  box-sizing: border-box;
  transition: transform 0.2s cubic-bezier(0.2, 0, 0, 1), box-shadow 0.2s ease, background 0.15s ease;
}

.feature-item:hover {
  background: #fafafa;
}

.feature-item:active {
  transform: scale(0.97);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.feature-icon {
  width: 24px;
  height: 24px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.feature-text {
  font-size: 15px;
  color: #333;
}

.disabled-feature {
  opacity: 0.5;
}

/* 底部导航栏 */
.custom-tabbar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: calc(56px + env(safe-area-inset-bottom, 0px));
  padding-bottom: env(safe-area-inset-bottom, 0px);
  background: #fff;
  backdrop-filter: saturate(180%) blur(30px);
  -webkit-backdrop-filter: saturate(180%) blur(30px);
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 10;
}

.custom-tabbar .tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex: 1;
  padding: 4px 0;
  transition: opacity 0.15s ease;
}

.custom-tabbar .tab-item:active {
  opacity: 0.6;
}

.custom-tabbar .tab-text {
  margin-top: 3px;
  font-size: 12px;
  color: #707070;
}

.custom-tabbar .tab-item.active .tab-text {
  color: #007AFF;
}

.custom-tabbar .tab-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 滑动动画 */
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  width: 100%;
}

.slide-left-leave-active,
.slide-right-leave-active {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.slide-left-enter-from { transform: translateX(100%); }
.slide-left-enter-to { transform: translateX(0); }
.slide-left-leave-from { transform: translateX(0); }
.slide-left-leave-to { transform: translateX(-100%); }

.slide-right-enter-from { transform: translateX(-100%); }
.slide-right-enter-to { transform: translateX(0); }
.slide-right-leave-from { transform: translateX(0); }
.slide-right-leave-to { transform: translateX(100%); }

/* 全屏弹窗 */
.share-page-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: #fff;
}

/* 新用户提示样式 */
.new-user-toast {
  position: fixed;
  top: 10px;
  left: 10px;
  right: 10px;
  background: #4CAF50;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  z-index: 99999;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  will-change: transform, opacity;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
}

.toast-icon {
  width: 24px;
  height: 24px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
}

.toast-text {
  flex: 1;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
}

.toast-close {
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  flex-shrink: 0;
}

.toast-close:hover {
  opacity: 1;
}

.toast-close:active {
  transform: scale(0.85);
}

/* 提示滑入动画 */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.slide-down-enter-from {
  transform: translateY(-100%) translateZ(0);
  opacity: 0;
}

.slide-down-enter-to {
  transform: translateY(0) translateZ(0);
  opacity: 1;
}

.slide-down-leave-from {
  transform: translateY(0) translateZ(0);
  opacity: 1;
}

.slide-down-leave-to {
  transform: translateY(-100%) translateZ(0);
  opacity: 0;
}

/* 管理页面样式 */
.management-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: #f5f5f5;
}

.management-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #eee;
  position: sticky;
  top: 0;
  z-index: 10;
  flex-shrink: 0;
}

.back-btn {
  background: none;
  border: none;
  font-size: 16px;
  color: #007AFF;
  cursor: pointer;
  padding: 4px 8px;
  margin-right: 12px;
}

.header-title {
  font-size: 17px;
  font-weight: 600;
  color: #333;
}

.management-content {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
  -webkit-overflow-scrolling: touch;
  min-height: 0;
}
</style>
